import React from 'react';
import PropTypes from 'prop-types';
import {
    getHeader,
    getFooter,
} from '../src/adapters/contentful.adapter';

import OptIn from '../src/components/OptIn/OptIn';

const DigitalCampaignDoubleOptIn = (props) => {
    const { header, footer, pageInfo } = props;
    return (
        <OptIn header={header} footer={footer} pageInfo={pageInfo} />
    );
};

DigitalCampaignDoubleOptIn.propTypes = {
    footer: PropTypes.object,
    header: PropTypes.object,
    pageInfo: PropTypes.object,
};

DigitalCampaignDoubleOptIn.getInitialProps = async () => {
    const header = await getHeader();
    const footer = await getFooter();

    return {
        header,
        footer,
        pageInfo: {
            breadcrumbsTitle: '登録ありがとう campaign',
            url: '/digital-doubleoptin',
            title: 'ウィスパークラブの会員登録メール認証が完了いたしました。',
            description: 'ウィスパークラブの会員登録完了ページです。お得な情報や、尿漏れ対策、妊娠初期、介護従事者向けを含む有益な情報をお届けします。',
            ogTitle: 'ウィスパークラブの会員登録メール認証が完了いたしました。',
            ogDescription: 'ウィスパークラブの会員登録完了ページです。お得な情報や、尿漏れ対策、妊娠初期、介護従事者向けを含む有益な情報をお届けします。',
            canonicals: {
                breadcrumbsTitle: '登録ありがとう campaign',
                url: '/digital-doubleoptin/',
                items: [{ canonical: '/digital-doubleoptin/' }],
            },
        },
    };
};

export default DigitalCampaignDoubleOptIn;
